import { Star } from '@mui/icons-material';
import {
  Box,
  Stack,
  TableCell,
  TableRow,
  Typography,
  styled
} from '@mui/material';
import { CustomIcons } from 'modules/components/layer00';
import { useNavigate } from 'react-router-dom';
import { theme } from 'theme';



const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.primary.light05
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0
  },
  ':hover': {
    backgroundColor: '#F4F4F4'
  }
}));



export type CompanyTableRowProps = {
  id: string;
  symbol: string;
  name: string;
  price: Big | null;
  change: Big | null;
  percentageChange: Big | null;
  volume: string;
  avgVol: string;
  marketCap: string;
  peRatio: Big | null;
  price52Low: Big | null;
  price52High: Big | null;
};

export const FC = (props: CompanyTableRowProps) => {
  const navigate = useNavigate();
  window.document.activeElement?.checkVisibility();
  return (
    <StyledTableRow
      id={props.id}
      onClick={() => navigate(`/company/${props.id}`)}
      sx={{
        cursor: 'pointer'
      }}
    >
      <TableCell
        variant='body'
        sx={{
          flex: '2 1 0'
        }}
      >
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='flex-end'
        >
          <Box>
            <Star color='primary' />
          </Box>
          {props.symbol}
        </Stack>
      </TableCell>

      <TableCell variant='body'>
        {props.name}
      </TableCell>

      <TableCell
        sx={{
          flex: '2 1 0'
        }}
        variant='body'
      >
        {props.price?.toFixed(2)}
      </TableCell>
      <TableCell
        sx={{
          flex: '3 1 0'
        }}
        variant='body'
      >
        {props.change?.gte(0)
          ? <CustomIcons.SmallCustomIcon.FC icon='STATPOS' stroke={theme.palette.primary.main} />
          : <CustomIcons.SmallCustomIcon.FC icon='STATNEG' stroke={theme.palette.warning.main} />}

        <Typography
          variant='tableCellLink'
          sx={{
            pl: 1
          }}
          color={
            props.change?.gte(0) ? theme.palette.primary.main : theme.palette.warning.main
          }
        >
          {props.change?.toFixed(2)}
        </Typography>
      </TableCell>

      <TableCell
        sx={{
          flex: '3 1 0',
          flexWrap: 'nowrap',
          textAlign: 'right'
        }}
        variant='body'
      >
        {props.percentageChange?.gte(0)
          ? <CustomIcons.SmallCustomIcon.FC icon='STATPOS' stroke={theme.palette.primary.main} />
          : <CustomIcons.SmallCustomIcon.FC icon='STATNEG' stroke={theme.palette.warning.main} />}

        <Typography
          variant='tableCellLink'
          sx={{
            pl: 1
          }}
          textOverflow='ellipsis'
          noWrap={true}
          color={
            props.percentageChange?.gte(0) ? theme.palette.primary.main : theme.palette.warning.main
          }
        >
          {props.percentageChange?.mul(100).toFixed(2)} %
        </Typography>

      </TableCell>
      <TableCell
        sx={{
          flex: '2 1 0'
        }}
        variant='body'
      >
        {props.volume}
      </TableCell>
      <TableCell variant='body'>
        {props.avgVol}
      </TableCell>
      <TableCell
        sx={{
          flex: '2 1 0'
        }}
        variant='body'
      >
        {props.marketCap ? props.marketCap : '-'}
      </TableCell>
      <TableCell
        sx={{
          flex: '2 1 0'
        }}
        variant='body'
      >
        {props.peRatio ? props.peRatio.toFixed(2) : '-'}
      </TableCell>

      {props.price52Low && props.price52High
        ? (
          <TableCell
            sx={{
              flex: '2 1 0'
            }}
            variant='body'
          >
            {props.price52Low.lte(props.price52High) ? props.price52Low.toFixed(2) : props.price52High.toFixed(2)} - {props.price52Low.gte(props.price52High) ? props.price52Low.toFixed(2) : props.price52High.toFixed(2)}
          </TableCell>
        )
        : (
          <TableCell
            sx={{
              flex: '2 1 0'
            }}
            variant='body'
          >
            -
          </TableCell>
        )}
    </StyledTableRow>
  );
};
